module.exports = __webpack_public_path__ + "img/preview.da848b2e.jpeg";